import axios from 'axios'
import history from '../history'
import { COOKIE_STOAGE } from '../Utils/Storage'
import { BASE_URL } from '../Utils/constants'
import stores from '../Stores'
import { messageNotification } from '../Utils/notification'
import { routes } from '../routes'

class FetchBase {
  serialize(obj = {}) {
    return Object.keys(obj).length
      ? '?' +
          Object.keys(obj)
            .map(
              (k) => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`
            )
            .join('&')
      : ''
  }

  get headers() {
    return {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      devicetype: 'web',
      ...(COOKIE_STOAGE.getItem('token') && {
        Authorization: `jwt ${COOKIE_STOAGE.getItem('token')}`,
        orgid: COOKIE_STOAGE.getItem('organizationId'),
      }),
    }
  }

  getFormData(object = {}) {
    const formData = new FormData()
    for (const key in object) {
      formData.append(key, object[key])
    }
    return formData
  }

  constructUrl(url) {
    return BASE_URL + url
  }

  download({ filename, text }) {
    const pom = document.createElement('a')
    pom.setAttribute(
      'href',
      'data:text/csv;charset=utf-8,' + encodeURIComponent(text)
    )
    pom.setAttribute('download', filename)

    if (document.createEvent) {
      const event = document.createEvent('MouseEvents')
      event.initEvent('click', true, true)
      pom.dispatchEvent(event)
    } else {
      pom.click()
    }
  }

  async fetchMethod(url, options) {
    try {
      const response = await axios(url, options)
      if (response.status === 401) {
        let organizationList = COOKIE_STOAGE.getItem('organizationList')
        let isSuperUser = COOKIE_STOAGE.getItem('isSuperUser')
        let notAppliCableToRedirect =
          Boolean(organizationList?.length <= 1) || Boolean(isSuperUser) // User assigned in only one ORG or Platform side login and got error in API then user will logout
        notAppliCableToRedirect && COOKIE_STOAGE.removeItem('token')
        COOKIE_STOAGE.removeItem('user')
        // add new to remove cookie
        COOKIE_STOAGE.removeItem('isSuperUser')
        COOKIE_STOAGE.removeItem('isReseller')
        COOKIE_STOAGE.removeItem('organizationId')
        COOKIE_STOAGE.removeItem('organizationList')
        COOKIE_STOAGE.removeItem('role')
        notAppliCableToRedirect && COOKIE_STOAGE.removeItem('remember')
        //stores.resetStore()
        setTimeout(() => {
          notAppliCableToRedirect ? stores.navigate() : stores.navigateOrg()
          window.location.reload()
        }, 250)
      }
      const jsonRes = response.data
      if (jsonRes.success || jsonRes.status) {
        return jsonRes
      } else {
        messageNotification('error', jsonRes.message)
        jsonRes['__response'] = response
        throw jsonRes
      }
    } catch (e) {
      console.log(e)
      e.response?.data?.message &&
        messageNotification('error', e.response?.data?.message)
      throw e
    }
  }

  async downloadReport(url, data) {
    try {
      const response = await axios.get(
        this.constructUrl(url) + this.serialize(data),
        {
          headers: this.headers,
        }
      )
      const filename = response.headers['content-disposition'].split('"')[1]
      const text = response.data
      this.downloadReport({ filename, text })
    } catch (error) {
      throw new Error(error.message)
    }
  }

  get(url, data, signal) {
    let options
    if (signal) {
      options = {
        method: 'GET',
        headers: this.headers,
        signal,
      }
    } else {
      options = {
        method: 'GET',
        headers: this.headers,
      }
    }
    return this.fetchMethod(
      this.constructUrl(url) + this.serialize(data),
      options
    )
  }

  postBody(data = {}) {
    const dataNew = data || {}
    for (const key in dataNew) {
      if (dataNew[key] === undefined) {
        delete dataNew[key]
      }
    }
    const headers = this.headers
    if (headers['Content-Type'] === 'application/json') {
      return JSON.stringify(dataNew)
    } else {
      return this.getFormData(dataNew)
    }
  }

  post(url, data, signal) {
    return this.fetchMethod(this.constructUrl(url), {
      method: 'POST',
      data: this.postBody(data),
      headers: this.headers,
      signal,
    })
  }

  postWithFormData = (url, data) => {
    let newHeaders = this.headers
    delete newHeaders['Content-Type']
    return this.fetchMethod(this.constructUrl(url), {
      method: 'POST',
      data: data,
      headers: newHeaders,
    })
  }

  delete(url, data) {
    return this.fetchMethod(this.constructUrl(url), {
      method: 'DELETE',
      data: this.postBody(data),
      headers: this.headers,
    })
  }

  put(url, data) {
    return this.fetchMethod(this.constructUrl(url), {
      method: 'PUT',
      data: this.postBody(data),
      headers: this.headers,
    })
  }
}

export default FetchBase
